// extracted by mini-css-extract-plugin
export var divider = "_xy-0";